export const reCaptchaKey = () =>
  typeof window !== 'undefined' && window.manifest && window.manifest.reCaptchaKey
    ? window.manifest.reCaptchaKey
    : '6Ldsl5YUAAAAABAogZwhhL67wza6PcaGx0tBWbNt';

export const gMapApiKey = () =>
  typeof window !== 'undefined' && window.manifest && window.manifest.gMapApiKey
    ? window.manifest.gMapApiKey
    : 'AIzaSyAFq1fItucvNN8W751EX2dHcankbZcdFdA';

export const tenantId = () =>
  typeof window !== 'undefined' && window.manifest && window.manifest.tenantId
    ? window.manifest.tenantId
    : 90327182;

export const searchTrialUrl = () =>
  (typeof window !== 'undefined' && window.manifest && window.manifest.stAPI_baseURL
    ? window.manifest.stAPI_baseURL
    : 'https://uat-stapi.trialscope.com') +
  '/api/study/search?tenantId=' +
  tenantId() + '&_cache=' + (new Date());

export const subitFormUrl = (type) =>
  (typeof window !== 'undefined' && window.manifest && window.manifest.stAPI_baseURL
    ? window.manifest.stAPI_baseURL
    : 'https://uat-stapi.trialscope.com') +
  '/api/patientdatarequestform/aws' + type + '?tenantId=' +
  tenantId();

export const trialDetailsUrl = studyId =>
  (typeof window !== 'undefined' && window.manifest && window.manifest.stAPI_baseURL
    ? window.manifest.stAPI_baseURL
    : 'https://uat-stapi.trialscope.com') +
  '/api/study/?tenantId=' +
  tenantId() +
  '&uniqueStudyId=' +
  // '&Id=' +
  studyId + '&_cache=' + (new Date());

  export const allTrialsIds = () =>
  (typeof window !== 'undefined' && window.manifest && window.manifest.stAPI_baseURL
    ? window.manifest.stAPI_baseURL
    : 'https://uat-stapi.trialscope.com') +
  '/api/study/ids/all?tenantId=' +
  tenantId() + '&_cache=' + (new Date());

export const fileUploadMaxSize = () =>
  ((typeof window !== 'undefined' && window.manifest && window.manifest.upload_max_file_mb) || 1) * 1048576; // 1048576 = 1MB
